import React from 'react';
import classNames from 'classnames/bind';

import Dots from 'components/Dots';
import styles from './TooltipComponent.css';

const cx = classNames.bind(styles);

const Tooltip = ({
  step,
  size,
  primaryProps,
  skipProps,
  tooltipProps,
  onClickStep,
  totalStep,
}) => {
  // remove default title react joyride
  primaryProps.title = '';

  const buttonFooterClassName = getButtonClassNames();
  return (
    <div {...tooltipProps} className={styles['tooltip-wrapper']}>
      <div className={styles['tooltip-content']}>
        {step.title && (
          <span className={styles['tooltip-title']}>{step.title}</span>
        )}
        {step.content && (
          <div
            className={styles['tooltip-content']}
            dangerouslySetInnerHTML={{ __html: step.content }}
          />
        )}
      </div>
      <div className={styles['tooltip-footer']}>
        {size > 1 && (
          <Dots
            totalDots={totalStep === undefined ? size : totalStep}
            activeIndex={step.id - 1}
            onClick={onClickStep}
          />
        )}
        <button className={buttonFooterClassName} {...primaryProps}>
          {step.buttonText}
        </button>
      </div>
      <button className={styles['tooltip-close']} {...skipProps} />
    </div>
  );
};

const getButtonClassNames = () => {
  return cx('button-footer', 'btn', 'btn-primary');
};

export default Tooltip;
